var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4661_32176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#949494"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4661_32176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54813 14.5833C7.12715 14.5833 6.77083 14.4374 6.47917 14.1458C6.1875 13.8541 6.04167 13.4978 6.04167 13.0768V3.58971C6.04167 3.16874 6.1875 2.81242 6.47917 2.52075C6.77083 2.22909 7.12715 2.08325 7.54813 2.08325H14.5352C14.9562 2.08325 15.3125 2.22909 15.6042 2.52075C15.8958 2.81242 16.0417 3.16874 16.0417 3.58971V13.0768C16.0417 13.4978 15.8958 13.8541 15.6042 14.1458C15.3125 14.4374 14.9562 14.5833 14.5352 14.5833H7.54813ZM4.63146 17.4999C4.21049 17.4999 3.85417 17.3541 3.5625 17.0624C3.27083 16.7708 3.125 16.4144 3.125 15.9935V5.25638H4.375V15.9935C4.375 16.0576 4.40174 16.1164 4.45521 16.1697C4.50854 16.2232 4.56729 16.2499 4.63146 16.2499H12.8685V17.4999H4.63146Z",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCopyIcon);
export default __webpack_public_path__ + "static/media/active-copy-icon.5ace40087fdea4036dc515c61a7e6385.svg";
export { ForwardRef as ReactComponent };